import React, { useEffect } from "react";

import styles from "./PassionProfilePage.module.css";
import { useAcid } from "../../hooks/useAcid";
import { usePassionsStore } from "../../store";
import { Passions } from "./Passions/Passions";
import { useOfferDataForProfile } from "../../hooks/useOfferDataForProfile";
import CardSkeleton from "../OffersLandingPage/Card/CardSkeleton";
import Card from "../OffersLandingPage/Card";
import placeholderImage from "../../assets/images/img_placeholder.jpg";
import { passions } from "../OffersLandingPage/constants";
import { useMatchBreakpoint } from "../../hooks/useMatchBreakpoint";

export const PassionProfilePage = () => {
  const { acid } = useAcid();
  const { passions: passionsData, fetchPassions } = usePassionsStore();
  const { loading, data, bookNow } = useOfferDataForProfile(passionsData);

  useEffect(() => {
    if (acid) {
      fetchPassions(acid);
    }
  }, [acid, fetchPassions]);

  const renderSkeletons = () =>
    Array(6)
      .fill()
      .map((_, index) => (
        <div className={styles.cardWrapper} key={`skeleton-${index}`}>
          <CardSkeleton />
        </div>
      ));

  const renderCards = () => {
    return (data ?? []).map((property, index) => {
      const passion = passions[property.category];

      return (
        <div className={styles.cardWrapper} key={`skeleton-${index}`}>
          <Card
            title={property.name}
            description={property.description}
            image={
              property.imageUrl
                ? `https://cache.marriott.com/${property.imageUrl}`
                : placeholderImage
            }
            rating={property.reviews.rating || ""}
            reviewCount={property.reviews.count || "0"}
            isPassion={true}
            price={
              property.rate?.lowestAverageNightlyRate?.value ||
              property.rate?.firstNightLowestStay?.value ||
              ""
            }
            fee={
              property.rate?.lowestAverageNightlyRateFeeAmount ||
              property.rate?.firstNightLowestStayFeeAmount ||
              0
            }
            icon={passion?.icon}
            chip={passion?.chip}
            bookNow={bookNow}
            propertyData={property}
          />
        </div>
      );
    });
  };

  return (
    <section>
      <Passions passionsData={passionsData}></Passions>

      <div className={styles.content}>
        {loading ? renderSkeletons() : renderCards()}
      </div>
    </section>
  );
};
